import { useEffect, useState } from "react";

/**
 * The gatsby navigation state does not persist between page loads. This hook
 * allows you to persist state between page loads.
 * @param key
 * @param defaultValue
 * @returns
 */
export const usePersistState = <Type,>(
	key: string,
	defaultValue: Type,
): Type => {
	const [value, setValue] = useState();

	useEffect(() => {
		const getValue = () => {
			if (typeof window !== "undefined") {
				const persistedState = window.localStorage.getItem(key);
				return defaultValue || JSON.parse(persistedState);
			}
			return undefined;
		};
		const value = getValue();
		if (value) {
			setValue(value);
			window.localStorage.setItem(key, JSON.stringify(value));
		}
	}, [key, defaultValue]);
	return value;
};
